import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import {
    homeNode,
    workflowRepository,
} from "motw_core/Repositories/WorkflowRepository";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import { RefreshVisibleWorkflowNodesAsync } from "source/app/presentation/MainPanel/Workflows/Helpers/RefreshVisibleWorkflowNodes";
import { GetWorkflowsState } from "source/app/presentation/MainPanel/Workflows/Workflows";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import {
    TouchWorkflowNodeParentsAsync,
    UpdateWorkflowNodeStateLocally,
} from "./TouchWorkflowNodeParentsAsync";

export async function UpdateNodeAsync(
    node: IWorkflowNode,
    changes: Partial<IWorkflowNode>
) {
    await WithAnimatedProgressBarAsync(() =>
        UpdateNodeOnClientAsync(node, changes)
    );

    await WithAnimatedProgressBarAsync(() =>
        UpdateNodeInDatabaseFromClientAsync(node, changes)
    );

    await RefreshVisibleWorkflowNodesAsync();
}

export async function UpdateNodeInDatabaseFromClientAsync(
    node: IWorkflowNode,
    changes: Partial<IWorkflowNode>
) {
    await workflowRepository.UpdateNodeInDatabaseAsync(
        node,
        changes,
        ClientDataProvider
    );

    const lastModifiedTime = await TouchWorkflowNodeParentsAsync([
        node.parentid,
        changes.parentid,
    ]);

    UpdateWorkflowNodeStateLocally(node, changes, lastModifiedTime);
}

async function UpdateNodeOnClientAsync(
    node: IWorkflowNode,
    changes: Partial<IWorkflowNode>
) {
    const workflows = GetWorkflowsState();
    const visibleNodes = workflows.state.visibleNodes;
    let nodeToUpdate = visibleNodes.find((n) => n.id === node.id);

    if (!nodeToUpdate) {
        nodeToUpdate = homeNode;
    }

    nodeToUpdate = { ...node, ...changes };
    workflows.setState({ visibleNodes });
}
